module.exports = __webpack_public_path__ + "static/img/ap4.5e612a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap4.jpg
// module id = 2j4/
// module chunks = 1